<!--
  As of 2020-05-26, this is a copy of the Events/Event.vue template.
  We can modify it as needed to make it work for Network Registrations.
-->
<template>
    <div :class="cssClasses">
        <div class="eventInformation networkInformation">
            <v-container class='pt-0'>
                <v-layout row wrap>
                    <v-flex sm7 class='information'>
                        <h4 v-if="extract('event.open')">Apply for</h4>
                        <h3 v-html="extract('event.content.body.title') || extract('event.name')"></h3>
                        <div class="event-description" v-html="extract('event.content.body.description')"></div>
                        <table class="event-sections" v-if="extract('event.content.body.sections')">
                            <tr v-for="(obj, num) in extract('event.content.body.sections')" v-bind:key="num">
                                <td class="rowLabel"><h4 class="section-title">{{ extract('event.content.body.sections.'+num+'.title') }}:</h4></td>
                                <td v-html="extract('event.content.body.sections.'+num+'.html')"></td>
                            </tr>
                        </table>
                        <div class="event-closing" v-if="extract('event.content.body.closing')" v-html="extract('event.content.body.closing')"></div>
                        <div>
                            <span class="capacity-notice" v-if="!loading && availableSlots < 1">The network is currently at capacity, but sign up below to be added to the wait list and we'll email you if a spot opens up.</span>
                        </div>
                    </v-flex>
                    <v-flex sm4 offset-sm1 class='callout'>
                        <!-- IF DEFAULT ASIDE -->
                        <div class='whiteBox pa-4 mb-4 hidden-xs-only' v-if="hasAside" >
                            <div v-if="hasAside">
                                <div v-if="defaultAside">
                                    <!-- <p><img src="@/assets/es/Summit_SideCallout.svg" style='max-height: 200px; max-width:100%' /></p> -->
                                    <p><v-img src='@/assets/es/Summit_01@2x.jpg' /></p>
                                    <p><v-img src='@/assets/es/Summit_02@2x.jpg' /></p>
                                </div>
                               <div v-else class="customAside">
                                <AmazeDynamicComponent v-bind:template="extract('event.content.aside.html')"></AmazeDynamicComponent>
                            </div>
                            </div>
                        </div>
                        <!-- END DEFAULT ASIDE -->
                        <div id="refund-dialog">
                            <v-dialog v-model="dialog" max-width="500px">
                            <v-btn slot="activator"
                                   color="primary"
                                   style="display: none;"
                                   id="refund-dialog-button"
                                   class="mb-4 mt-4 ml-0">
                                Learn more about RTI's refund and cancellation policy
                            </v-btn>
                            <v-card>
                                <v-card-title>
                                    <h3 class="headline">Refund and Cancellation Policy</h3>
                                </v-card-title>
                                <hr class="thick" >

                                <v-card-text>
                                    <v-layout wrap>
                                        <div class='pa-2 mb-2'>
                                            <p>The {{ event.name }} Cancellation and Refund Policy will be as follows to assure consistency and is applicable to this network.</p>
                                            <p>{{ event.name }} application canceled online on or before {{ getFormattedDate(event.refund_expiry) }} is refundable if already paid, or not due if not already paid. In order for your cancellation to be received, email <a href="mailto:educationservices@rti.org ">educationservices@rti.org</a> no later than {{ getFormattedDate(event.refund_expiry) }}.</p>
                                        </div>
                                    </v-layout>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            color="blue darken-1"
                                            flat
                                            @click="dialog=false">Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <!-- BEGIN THE FORMATIONING -->
        <div class="registrationForm" v-if="!loading">
            <div class="text-xs-center" v-if="!extract('event.open')">
                <h4>Application is closed for this network.</h4>
            </div>
            <v-form ref="regForm" v-model="valid" v-if="!this.extract('event.content.form.custom') && extract('event.open')">
                <v-container>
                    <v-layout row wrap>
                        <v-flex md6>
                            <h3>Application <small>Required fields <span class='star'>*</span></small></h3>

                            <h5>Contact Information</h5>

                            <v-text-field v-model="lastName" required :rules="rules.populated">
                                <template slot="label">Last Name<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field v-model="firstName" required :rules="rules.populated">
                                <template slot="label">First Name<span class='star'>*</span></template>
                            </v-text-field>

                            <!-- NOT SURE THIS SHOULD BE REQUIRED -->
                            <v-text-field id="middleInitial" class="small" v-model="middleInitial" required mask="A" :rules="rules.populated">
                                <template slot="label">Middle Initial<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field id="phoneNumber" class="medium" v-model="phoneNumber" required mask="(###) ### - ####" :rules="rules.phone">
                                <template slot="label">Phone Number<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="personalEmail" >
                                <template slot="label">Personal Email</template>
                            </AmazeEmailAddressInput>

                            <AmazeEmailAddressInput v-model="schoolEmail" >
                                <template slot="label">School Email</template>
                            </AmazeEmailAddressInput>

                            <h5>Home Address</h5>

                            <AmazeAddress :address="homeAddress"></AmazeAddress>

                            <h5>Licensure Information</h5>

                            <p><strong>Do you currently hold a teaching license (e.g. lateral entry, emergency, permit to teach, residency)?<span class='star'>*</span></strong></p>

                            <v-radio-group v-model="hasLicense" required :mandatory="true" :rules="rules.populated">
                              <v-radio label="Yes" value="Yes"></v-radio>
                              <v-radio label="No" value="No"></v-radio>
                            </v-radio-group>

                            <v-select v-if="hasLicense === 'Yes'" :items="licenses" v-model="license">
                              <template slot="label">
                                What teaching license do you hold?
                              </template>
                            </v-select>

                            <v-text-field v-if="license === 'Other'" v-model="licenseOther">
                                <template slot="label">You selected Other, please tell use about your teaching license.</template>
                            </v-text-field>

                            <v-select v-if="hasLicense === 'Yes' && license === 'Residency License'" :items="residencyYears" v-model="residence">
                              <template slot="label">
                                What year are you in residence?
                              </template>
                            </v-select>

                            <v-text-field v-if="hasLicense === 'Yes'" v-model="licenseExpires" required mask="####">
                                <template slot="label">In what year does the license you hold expire?</template>
                            </v-text-field>

                            <v-text-field v-model="subject" required :rules="rules.populated">
                                <template slot="label">In what subject area do you teach?<span class='star'>*</span></template>
                            </v-text-field>

                            <v-select :items="subjectAreas" v-model="subjectArea" required :rules="rules.populated">
                              <template slot="label">
                                In what subject area are you seeking licensure?<span class='star'>*</span>
                              </template>
                            </v-select>

                            <h5>School Information</h5>

                            <v-text-field v-model="districtName" required :rules="rules.populated">
                                <template slot="label">School District<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field v-model="schoolName" required :rules="rules.populated">
                                <template slot="label">Name of School where you teach<span class='star'>*</span></template>
                            </v-text-field>

                            <v-text-field v-model="principalName" required :rules="rules.populated">
                                <template slot="label">Principal Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="principalEmail" >
                                <template slot="label">Principal Email Address</template>
                            </AmazeEmailAddressInput>

                            <v-text-field v-model="coachName" required :rules="rules.populated">
                                <template slot="label">Coach/Mentor Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="coachEmail">
                                <template slot="label">Coach/Mentor Email Address</template>
                            </AmazeEmailAddressInput>

                            <v-text-field v-model="hrName" required :rules="rules.populated">
                                <template slot="label">District Human Resources Contact Name<span class='star'>*</span></template>
                            </v-text-field>

                            <AmazeEmailAddressInput v-model="hrEmail">
                                <template slot="label">District Human Resources Email Address</template>
                            </AmazeEmailAddressInput>

                            <h5>Teaching and Learning Questions</h5>

                            <p>This portion of the application is intended to gather information about your teaching philosophy as well as your ability to organize and clearly communicate your ideas through writing. Please provide focused and detailed responses to the prompts below ensuring that you respond to each guiding question and that you use appropriate grammar, correct spelling, and complete sentences. <strong>Be sure to review your responses prior to submitting your application.</strong></p>
                            <br>

                            <p><strong>What made you want to become a teacher?</strong><span class='star'>*</span></p>
                            <p><b>Response</b> (Please limit your response to 300 words or less)</p>
                            <v-textarea outline v-model="teacherInspiration" required :rules="rules.populated"></v-textarea>

                            <p><strong>What does your ideal classroom look like?</strong><span class='star'>*</span></p>
                            <p>Address the following:</p>
                                <ul><li>How would you describe the classroom culture?</li>
                                <li>What are students doing?</li>
                                <li>What are you doing?</li></ul>

                            <p><b>Response</b> (Please limit your response to 300 words or less)</p>
                            <v-textarea outline v-model="idealClassroom" required :rules="rules.populated"></v-textarea>

                            <p><strong>In what ways do you teach students from diverse backgrounds who come to your classroom with diverse learning experiences?</strong><span class='star'>*</span></p>
                             <p><b>Response</b> (Please limit your response to 300 words or less)</p>
                            <v-textarea outline v-model="diverseBackgrounds" required :rules="rules.populated"></v-textarea>

                             <p><strong>Describe a challenge or professional risk that you have overcome and that you are proud of. What was the impact of the challenge or professional risk?</strong><span class='star'>*</span></p>
                             <p>Address the following:</p>
                                <ul>
                                  <li>What was the challenge or professional risk?</li>
                                  <li>What kept you motivated as you navigated the situation?</li>
                                  <li>What did you learn from the situation and your response?</li>
                                  <li>What role -- if any -- did feedback from others have in your response?</li>
                                </ul>

                            <p><b>Response</b> (Please limit your response to 300 words or less)</p>
                            <v-textarea outline v-model="challenges" required :rules="rules.populated"></v-textarea>

                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 class="mt-20" >
                            <div class="submit-wrapper" v-if="registrants > 0" >
                                <div class="submit-success" v-if="this.submittedSuccessfully">
                                     <h5>Success!</h5>
                                    <p><strong>Thank you for submitting your application.</strong> We have received your submission and will be in touch soon. To complete your application packet please submit the following items by email to <a href="mailto:fnash@rti.org">fnash@rti.org</a>.</p>
                                    <ul>
                                      <li>Resume</li>
                                      <li>All undergraduate and graduate transcripts</li>
                                      <li>Praxis II scores</li>
                                      <li>Copy of current license</li>
                                    </ul>
                                </div>
                                <div class="submit-incomplete" v-else>
                                    <h5 v-if="terms || acknowledgement">Application Signature</h5>
                                    <div v-if="terms || acknowledgement">
                                        <!-- <div id="netTermsWrapper">
                                          <iframe id="terms" :src="termsEmbedUrl" width="100%" height="400" embedded="true" frameborder="0"></iframe>
                                          <a class="hidden" ref="termsDownload" download="terms.pdf" :href="terms"><v-icon>cloud_download</v-icon>  Download PDF</a>
                                          <v-btn @click="downloadTerms" class="mx-0" color="secondary"><v-icon>cloud_download</v-icon>&nbsp; Download PDF</v-btn>
                                        </div> -->

                                        <div v-if="acknowledgement">
                                          <v-checkbox
                                            required
                                            :rules="rules.acknowledge"
                                            v-model="acknowledge"
                                            :disabled="acknowledge"
                                            :label="`By checking this box, I acknowledge that the information in this application is true and all the responses are my own.`"
                                          ></v-checkbox>
                                        </div>
                                         <div v-if="acknowledgement" v-html="acknowledgement" id="acknowledgement"></div>
                                    </div>
                                    <v-btn v-if="!submitted" class='ml-0' color="primary" @click="submitRegistration()">Submit Application</v-btn>
                                    <v-progress-circular v-else indeterminate />
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </div>

        <!-- END THE FORMATIONING -->

    </div>
</template>
<style scoped lang="scss">
.small {
  &.v-input {
    width: 8em;
  }
}
.medium {
  &.v-input {
    width: 15em;
  }
}

#terms {
  max-height: 400px;
  overflow-y: scroll;
  overflow: scroll;
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #707070;
}

</style>
<script>
import moment from 'moment'
import AmazeAddress from "@/components/Widgets/AmazeAddress"

import registrationMixin from "@/mixins/registrationMixin.js";

export default {
  mixins: [registrationMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,
      acknowledge: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      lastName: '',
      firstName: '',
      middleInitial: '',
      phoneNumber: '',
      personalEmail: '',
      schoolEmail: '',
      homeAddress: {
        street: null,
        city: null,
        state: null,
        zip: null
      },
      hasLicense: '',
      license: '',
      licenseOther: '',
      residence: '',
      licenseExpires: '',
      subject: '',
      subjectArea: '',
      schoolName: '',
      districtName: '',
      principalName: '',
      principalEmail: '',
      coachName: '',
      coachEmail: '',
      hrName: '',
      hrEmail: '',
      teacherInspiration: '',
      idealClassroom: '',
      diverseBackgrounds: '',
      challenges: '',

      roles: ['Principal', 'Lead Teacher', 'Lead Counselor', 'College Liaison', 'Other'],

      licenses: ['Residency License', 'Emergency License', 'Permit to Teach', 'Other'],

      residencyYears: ['1', '2', '3'],

      subjectAreas: ['Art, K-12', 'Elementary Education', 'Health & Physical Education, K-12', 'Music, K-12', 'Anthropology, 9 -12', 'Biology, 9 -12', 'Chemistry, 9-12', 'CTE: Agricultural Education', 'CTE: Business & Information Technology Education', 'CTE: Family & Consumer Sciences', 'CTE: Health Sciences Education', 'CTE: Marketing Education', 'CTE: Technology Education', 'CTE: Trade & Industrial Education', 'Earth Science, 9- 12', 'Economics, 9- 12', 'English, 9-12', 'Geography, 9-12', 'History, 9 – 12', 'Mathematics, 9 -12', 'Middle Grades – Mathematics', 'Middle Grades – Language Arts', 'Middle Grades – Science', 'Middle Grades – Social Studies', 'Physics', 'Political Science', 'Science, 9 -12', 'Social Studies, 9-12', 'Sociology, 9 – 12', 'Special Education: General Curriculum, K-12', 'Theater Arts, K-12'],

      yesorno: ['Yes', 'No'],

      registrants: 4,
      numRegistrants: 4,
      registrant: [{
        name: '',
        email: null,
        role: 'Aspire Teacher'
      }],
      submittedSuccessfully: false,
      rules: {
        name: [v => !!v || "Name is required."],
        email: [
          v => !!v || "Email is required.",
          v => /@/.test(v) || "Please enter a valid email."
        ],
        phone: [v => !!v || "Phone Number is required.",
          v => (v || '').length === 10 || "Please enter a valid phone number."],
        populated: [v => !!v || "This field is required"],
        role: [v => !!v || "Role is required."],
        school: [v => !!v || "School name is required."],
        district: [v => !!v || "District name is required."],
        acknowledge: [v => !!v || "Please accept the terms and conditions."]
      },
      event: {}
    };
  },
  watch: {

  },
  computed: {
    name() {
      return this.firstName + ' ' + this.middleInitial + ' ' + this.lastName;
    },
    teachingLicense() {
      if (this.license === 'Other') {
        return 'Other - ' + this.licenseOther;
      }
      return this.license;
    },
    termsEmbedUrl() {
      return "https://docs.google.com/viewer?url=" + this.terms + "&embedded=true&chrome=true"
      // return this.terms + "#toolbar=1";
      // return "http://docs.google.com/gview?&embed=true&url=" + this.terms;
    },
    defaultSchool() {
      return {
        street: null,
        city: null,
        state: null,
        zip: null
      };
    },
    content() {
      return event.content ? event.content : false;
    },
    id() {
      return this.extract('event.id');
    },
    terms() {
      return this.extract('event.content.terms', false);
    },
    acknowledgement() {
      return this.extract('event.content.acknowledgement', false);
    },
    membershipOptions () {
      return this.extract('event.content.membershipOptions', false);
    },
    showWaiver() {
      // By default, we should be showing the waiver. However, if the waiver meta entry is set
      // to false, that indicates we should not show the waiver.
      return this.extract('event.content.meta.waiver', true);
    },
    hasAside() {
      var aside = this.extract('event.content.aside.custom');
      return aside !== null && typeof aside !== 'undefined';
    },
    defaultAside() {
      return !this.extract('event.content.aside.custom') || !this.extract('event.content.aside.html');
    },
    registrationIsSingle() {
      return false;
    },
    registrantSlots() {
      let slots = [];
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + " attendee", value: i });
        } else {
          slots.push({ text: i + " attendees", value: i });
        }
      }
      return slots;
    },
    contactAddress() {
      return process.env.VUE_APP_CONTACT_ADDRESS;
    },
    loaded() {
      return !this.loading;
    },
    showSubmitPrompt() {
      return !this.submittedSuccessfully && this.registrants > 0;
    }
  },
  methods: {
    formatPhoneNumber(number) {
      if (!(typeof number === 'string' || number instanceof String)) {
        number = '' + number;
      }

      if (number.length === 10) {
        return number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
      }

      return '';
    },
    downloadTerms: function() {
      this.$refs.termsDownload.click();
    },
    getFormattedDate: function (date) {
      return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
    },
    extract: function(valueString, defaultValue) {
      var keys = valueString && valueString.length ? valueString.split('.') : [];

      var numKeys = keys.length;

      var object = null;

      // Set null as default value if not defined.
      if (typeof defaultValue === 'undefined') {
        defaultValue = null;
      }

      if (numKeys > 0 && keys[0] !== null && this.hasOwnProperty(keys[0])) {
        object = this[keys[0]];
      } else {
        return defaultValue;
      }

      for (var i = 1; i < numKeys; i++) {
        var key = keys[i];
        if (key !== null && object !== null && object.hasOwnProperty(key)) {
          object = object[key];
        } else {
          return defaultValue;
        }
      }

      return object;
    },
    initializeSlots() {
      let backup = this.registrant;
      this.registrant = [];
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person];
        } else {
          this.registrant[person] = {
            name: '',
            email: null,
            role: null
          };
        }
      }
    },
    submitRegistration() {
      if (this.$refs.regForm.validate()) {
        this.submitted = true;
        // The principal is registrant 1 (i.e. 0 index) and must accept terms
        // to submit.
        this.registrant[0].terms = this.acknowledge;
        this.registrant[0].name = this.name;
        this.registrant[0].email = this.personalEmail;
        this.registrant[0].role = 'Aspire Teacher';
        let data = {
          school: this.schoolName,
          district: this.districtName,
          name: this.name,
          email: '',
          registration_team_member: this.registrant,
          // state: this.schoolAddress.state, // Not relevant to aspire.
          team_total: 1, // Not relevant to aspire.
          registration_event_id: this.extract('event.id'),
          single_registration: false, // this may actually be true, but I'm not sure of the ramifactions of setting it true.
          extra_attributes: {
            lastName: this.lastName,
            firstName: this.firstName,
            middleInitial: this.middleInitial,
            phoneNumber: this.formatPhoneNumber(this.phoneNumber),
            personalEmail: this.personalEmail,
            schoolEmail: this.schoolEmail,
            homeAddress: this.homeAddress,
            hasLicense: this.hasLicense,
            license: this.teachingLicense,
            residence: this.residence,
            licenseExpires: this.licenseExpires,
            subject: this.subject,
            subjectArea: this.subjectArea,
            schoolName: this.schoolName,
            districtName: this.districtName,
            principalName: this.principalName,
            principalEmail: this.principalEmail,
            coachName: this.coachName,
            coachEmail: this.coachEmail,
            hrName: this.hrName,
            hrEmail: this.hrEmail,
            teacherInspiration: this.teacherInspiration,
            idealClassroom: this.idealClassroom,
            diverseBackgrounds: this.diverseBackgrounds,
            challenges: this.challenges
          }
        };

        this.$http.post('registrations', data).then(
          response => {
            this.submittedSuccessfully = true;
            if (this.$route.query.debug) {
              this.submittedSuccessfully = false;
              this.submitted = false;
            }
          },
          response => {
            this.submitted = false;
            this.$store.commit("updateMessage", {
              message: "There was a problem saving your registration. Please try again or contact support.",
              snackbar: true
            });
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message: "Required fields are missing. Please review the form.",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    this.$http.get('event/aspire-teacher-prep-2020').then((response) => {
      this.event = response.data.data[0];

      this.totalAttendees = this.extract('event.total_attendees') || 0;
      this.maxAttendees = this.extract('event.max_attendees') || 0;

      this.availableSlots = Math.max(0, this.maxAttendees - this.totalAttendees);

      this.maxRegistrants = this.extract('event.max_per_team');
      // If we need to limit registration to only accept the max number of slots, we can use the following logic:
      // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

      if (this.maxRegistrants === 1) {
        // Single registration, set-up initial object to avoid null object errors.
        this.registrant.push({ "name": '', "email": null, role: null });
        this.registrants = 1;
      }

      this.loading = false;
    // eslint-disable-next-line handle-callback-err
    }, error => {
      this.$router.push('/404')
    });
  },
  components: {
    AmazeAddress
  }
}
</script>
